import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  dialog: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  paper: {
    minWidth: 300,
    maxWidth: 640,
    width: '100%',
    borderRadius: 28,
    overflowY: 'visible',
  },
  dialogTitle: {
    textAlign: 'center',
    padding: 0,
  },
  dialogHeading: {
    fontSize: 28,
    color: '#000',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  dialogContent: {
    padding: '48px 32px',
    // overflowY: 'visible',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(4),
    top: theme.spacing(4),
    color: theme.palette.grey[500],
  },
}));
